import Breadcrumb from "components/Breadcrumb/Breadcrumb";
import { useFetchSampleOptions } from "global/hooks/useFetchOptions";
import { paginationType } from "global/Interfaces/Interfaces";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeSurveySwitch, filterSurvey } from "redux/survey/survey";
import SurveySearch from "./table/Search";

import Paginations from "global/Pagination/Pagination";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addEditDataAPI } from "services/CRUDServices";
import { getDay } from "tools/functions/Methods";
import { SurveyCard } from "./components/SurveyCard";
import SurveyTopHeader from "./components/SurveyHeader";
import SurveyDetail from "./surevey-details";

const SurveyWithNewUi2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState<boolean>(false);
  const { dataOptions: replyTypeSelect } = useFetchSampleOptions(
    "/customer-api/question/replyTypeSelect"
  );
  const { dataOptions: questionTypeSelect } = useFetchSampleOptions(
    "/customer-api/question/questionTypeSelect"
  );
  const { dataOptions: questionAssessmentMethodSelect } = useFetchSampleOptions(
    "/customer-api/question/questionAssessmentMethodSelect"
  );

  const { surveyData, fetchpost, filter } = useSelector(
    (state: any) => state.SurveySlice
  );
  const { pageNumbers } = useSelector(
    (state: paginationType) => state.paginate
  );

  const [modals, setModals] = useState({
    surveyForm: { open: false, currentData: null as any },
    surveyDetail: { open: false, currentData: null as any },
  });

  const refreshTable = () => {
    dispatch(
      filterSurvey({
        ...filter,
        isActive:!isActive,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    );
  };

  const handelChangeStatus = async ( item: any) => {
    try {
      dispatch(changeSurveySwitch(item.id));
      const url = item.isActive
        ? `/customer-api/survey/s1/v1/deActivate/${item.id}`
        : `/customer-api/survey/s1/v1/activate/${item.id}`;
      await addEditDataAPI(
        url,
        "put",
        {}
      );

      refreshTable();
      toast.success("عملیات با موفقیت انجام شد ");
    } catch (error) {
      console.log(error);
    }
  };
console.log(isActive)
  return (
    <div className="w-full px-4 md:px-6 pb-10" dir="rtl">
      <Breadcrumb curentPage="فرم‌های نظر سنجی" beforePage="" />

      <div className="mt-3">
        <SurveyTopHeader
          isActive={isActive}
          onGoQuestionBank={() => {
            navigate("/basic-information/question-bank");
          }}
          onGoActiveSurveys={() => {
            const nextIsActive = !isActive;
            setIsActive(nextIsActive);
            dispatch(
              filterSurvey({
                ...filter,
                isActive: !nextIsActive,
                pageSize: 10,
                pageNumber: 1,
              }) as any
            );
          }}
          onGoDashboard={() => {
            navigate("/basic-information/survey-results");
          }}
          onCreateSurvey={() => navigate("/basic-information/survey-actions")}
        />
      </div>

      <SurveySearch
        isActive={isActive}
        options={{
          replyTypeSelect: replyTypeSelect?.options,
          questionTypeSelect:questionAssessmentMethodSelect?.options ,
          questionAssessmentMethodSelect:questionTypeSelect?.options,
        }}
      />

      <div className="mt-6">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-green-500" />

            <h2 className="text-lg font-bold text-[#7a1b2b]">
              {!isActive ? ` نظرسنجی‌های در جریان `:` نظرسنجی‌های غیرفعال `}
            </h2>
          </div>

          <div className="text-sm text-gray-500">
            نتیجه جستجو: {surveyData?.totalElements ?? 0} • نظرسنجی یافت شد
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {surveyData?.content?.map((c: any) => (
            <SurveyCard
              key={c.id}
              id={c.id}
              refreshTable={refreshTable}
              title={c.title}
              isActive={c.isActive}
              validFrom={getDay(c.validFrom)}
              validTo={getDay(c.validTo)}
              answersCount={c.answersCount}
              satisfactionPercent={c.satisfactionPercent}
              selectSurveyType={c.selectSurveyType?.text}
              questionType={c.selectQuestionAssessmentMethod?.text}
              modifier={c.modifier}
              author={c.author}
              createdDate={getDay(c.createdDate)}
              modifiedDate={getDay(c.modifiedDate)}
              onDetail={() =>
                setModals((prev) => ({
                  ...prev,
                  surveyDetail: { open: true, currentData: { id: c.id } },
                }))
              }
              onEdit={() => {
                navigate("/basic-information/survey-actions", {
                  state: {
                    currentData: surveyData.content.find(
                      (x: any) => x.id === c.id
                    ),
                  },
                });
              }}
              onChangeStatus={() => {
                handelChangeStatus(c);
              }}
            />
          ))}
        </div>
        <Paginations pageData={surveyData?.totalElements} />
      </div>

      <SurveyDetail
        open={modals.surveyDetail.open}
        surveyId={modals.surveyDetail.currentData?.id}
        setOpen={() =>
          setModals({
            ...modals,
            surveyDetail: { open: false, currentData: null },
          })
        }
      />
    </div>
  );
};

export default SurveyWithNewUi2;
